/** DEV OPTS*/
/* @flow */
/* @ts-check */

import { Dictionary } from '../types/types';
import { Appearance } from './utils-app';

/* eslint-env node*/
/* eslint-disable no-console */
/*
 * Coach Amigo React Hybrid App module
 * https://github.com/facebook/react-native
 * @version 1.0.0
 */

export const light = {
   'body-text': 'rgb(44, 44, 44)',
   'body-background': 'rgb(255,255,255)',
   black: 'rgb(0,0,0)',
   white: 'rgb(255,255,255)',
   'gray-darkest': 'rgb(44, 44, 44)',
   'gray-dark': 'rgb(70, 74, 70)',
   gray: 'rgb(160, 169, 186)',
   'gray-lightest': 'rgb(239, 240, 243)',
   'gray-light': 'rgb(231, 233, 237)',
   'gray-light2': 'rgb(205,216,205)',
   'gray-light3': 'rgb(172, 180, 172)',
   blue: 'rgb(100, 154, 255)',
   'blue-light': 'rgb(156, 190, 255)',
   red: 'rgb(255, 59, 59)',
   'green-lightest': 'rgb(250,255,250)',
   green: 'rgb(208, 237, 113)',
   green2: 'rgb(106, 206, 23)',
   'green-dark': 'rgb(75, 139, 22)',
   'green-darkest': 'rgb(42, 75, 16)',
   orange: 'rgb(255, 177, 0)',
   gold: 'rgb(215,169,35)',
   'drawer-background': 'rgb(53, 59, 53)',
   primary: 'rgb(42, 75, 16)',
   background: 'rgb(255,255,255)',
   card: 'rgb(255,255,255)',
   text: 'rgb(42, 75, 16)',
   border: 'rgb(231, 233, 237)',
   //CUSTOM
   'gray-dark-settings': 'rgb(70, 74, 70)',
   'green-settings': 'rgb(208, 237, 113)',
   'black-callsheet': 'rgb(0, 0, 0)',
   'blue-callsheet': 'rgb(100, 154, 255)',
   'green-callsheet': 'rgb(208, 237, 113)',
   'blue-tabbar': 'rgb(100, 154, 255)',
   'gray-tabbar': 'rgb(160, 169, 186)',
   'gray-dark-tabbar': 'rgb(70, 74, 70)',
   'gray-darkest-tabbar': 'rgb(44, 44, 44)',
   'blue-rating': 'rgb(100, 154, 255)',
   'soccer-pitch-green': 'rgb(208, 237, 113)',
   futsal: 'rgb(0, 153, 204)',
   'blue-chat': 'rgb(226, 236, 255)',
   'gray-lightest-chat': 'rgb(245, 245, 249)'
};

export const dark = {
   'body-text': 'rgb(220,220,220)',
   'body-background': 'rgb(25,25,25)',
   black: 'rgb(255,255,255)',
   white: 'rgb(0,0,0)',
   'gray-darkest': 'rgb(239, 240, 243)',
   'gray-dark': 'rgb(231, 233, 237)',
   gray: 'rgb(160, 169, 186)',
   'gray-lightest': 'rgb(33, 36, 43)',
   'gray-light': 'rgb(44, 47, 54)',
   'gray-light2': 'rgb(205,216,205)',
   'gray-light3': 'rgb(172, 172, 185)',
   blue: 'rgb(54 136, 215)',
   'blue-light': 'rgb(19, 93, 230)',
   red: 'rgb(255, 59, 59)',
   'green-lightest': 'rgb(250,255,250)',
   green: 'rgb(22, 139, 61)',
   green2: 'rgb(38, 194, 90)',
   'green-dark': 'rgb(75, 139, 22)',
   'green-darkest': 'rgb(42, 75, 16)',
   orange: 'rgb(255, 177, 0)',
   gold: 'rgb(215,169,35)',
   'drawer-background': 'rgb(53, 53, 63)',
   primary: 'rgb(239, 240, 243)',
   background: 'rgb(0,0,0)',
   card: 'rgb(0,0,0)',
   text: 'rgb(239, 240, 243)',
   border: 'rgb(30, 35, 40)',
   //CUSTOM
   'gray-dark-settings': 'rgb(30, 35, 40)',
   'green-settings': 'rgb(30, 35, 40)',
   'black-callsheet': 'rgb(20, 20, 20)',
   'blue-callsheet': 'rgb(10, 20, 50)',
   'green-callsheet': 'rgb(42, 75, 16)',
   'blue-tabbar': 'rgb(19, 93, 230)',
   'gray-tabbar': 'rgb(44, 47, 54)',
   'gray-dark-tabbar': 'rgb(44, 47, 54)',
   'gray-darkest-tabbar': 'rgb(100, 100, 110)',
   'blue-rating': 'rgb(19, 93, 230)',
   'soccer-pitch-green': 'rgb(22, 139, 61)',
   futsal: 'rgb(0, 90, 121)',
   'blue-chat': 'rgb(0, 29, 85)',
   'gray-lightest-chat': 'rgb(28, 32, 38)'
};

/*export const getColor = {
   rgb: (color: string): string=>{
      return light[color.replace('$','')];
   },
   rgba: (color: string, opacity: number): string=>{
      return light[color.replace('$','')].replace('rgb','rgba').replace(')',','+opacity+')');
   }
};*/

export const getColor = {
   rgb: (color: string): string => {
      const scheme: Dictionary = color.substr(0, 1) !== '$' || Appearance.getColorScheme() === 'light' ? light : dark;
      return scheme[color.replace('$', '')];
   },
   rgba: (color: string, opacity: number): string => {
      const scheme: Dictionary = color.substr(0, 1) !== '$' || Appearance.getColorScheme() === 'light' ? light : dark;
      return scheme[color.replace('$', '')] ? scheme[color.replace('$', '')].replace('rgb', 'rgba').replace(')', ',' + opacity + ')') : 'rgb(160, 169, 186)';
   }
};

export const getStyleTheme = (): Object => {
   const scheme: Dictionary = Appearance.getColorScheme() === 'light' ? light : dark;
   const new_scheme: Dictionary = {};
   for (let k in scheme) {
      new_scheme['$' + k] = scheme[k];
   }
   return new_scheme;
};
